import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  loaderContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  formControl: {
    width: "100%",
  },
  inputContainer: {
    textAlign: "left",
    borderBottom: "1px solid #efefef",
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2.5),
  },
  cardContent: {
    padding: 0,
    paddingBottom: theme.spacing(2.5),
  },
}));
